export default "__VITE_ASSET__Dkmg8wwi__"